import React from 'react';
import { arrayOf, bool, number, shape, string } from 'prop-types';

import Chevron from './Chevron';

const namespace = 'seo-landing-breadcrumb';

const BreadcrumbItem = ({ isLast, position, text, href }) => (
  <li
    className="andes-breadcrumb__item"
    itemProp="itemListElement"
    itemType="http://schema.org/ListItem"
    itemScope
  >
    {isLast ? (
      <span itemProp="name">{text}</span>
    ) : (
      <a
        href={href}
        title={text}
        itemProp="item"
        className="andes-breadcrumb__link"
      >
        <span itemProp="name">{text}</span>
      </a>
    )}
    <meta itemProp="position" content={position} />
    {!isLast && <Chevron className="andes-breadcrumb__chevron" />}
  </li>
);

BreadcrumbItem.propTypes = {
  isLast: bool.isRequired,
  position: number.isRequired,
  text: string.isRequired,
  href: string.isRequired,
};

const Breadcrumb = ({ value }) => {
  const { breadcrumbs: initialNodes } = value;
  const nodes = initialNodes || [];

  return (
    <div className={`${namespace}__wrapper`}>
      <div className={`${namespace}`}>
        {!!nodes.length && (
          <ol
            className="andes-breadcrumb"
            itemType="http://schema.org/BreadcrumbList"
            itemScope
          >
            {nodes.map((node, index) => (
              <BreadcrumbItem
                {...node}
                isLast={index === nodes.length - 1}
                position={index + 1}
                key={node.text}
              />
            ))}
          </ol>
        )}
      </div>
    </div>
  );
};

Breadcrumb.propTypes = {
  value: shape({
    breadcrumbs: arrayOf(
      shape({
        text: string.isRequired,
        href: string.isRequired,
      }),
    ),
  }),
};

export default Breadcrumb;
